import React from 'react';
import { EditClosingDateInline } from './EditClosingDateInline';
import { SmallBodyText } from '../../../../../../ui-toolkit';
import { SummaryItemWithTooltip } from '../../../../../shared/Summary/SummaryItem/SummaryItemWithTooltip';
import { useSelectCurrentOrder } from '../../../../../../selectors/order/selectCurrentOrder';
import { useUpdateOrderFromSummaryItem } from '../../hooks/useUpdateOrderFromSummaryItem';
import { getDateString } from '../../../../../../ui-toolkit/utilities/getDateString';

export const ClosingDate: React.FC = () => {
  const { data } = useSelectCurrentOrder();
  const { onPatchOrderInformation } = useUpdateOrderFromSummaryItem();

  const onClosingDate = async (value: string | null, reasonType: string | null, customReason: string | null) => {
    await onPatchOrderInformation({
      closingDate: {
        date: value,
        delayReasonType: reasonType,
        delayReason: customReason,
      },
    });
  };

  return (
    <SummaryItemWithTooltip
      label={`Closing Date`}
      tab={`summary`}
      data-test-id={'closing-date'}
      tooltip={EditClosingDateInline}
      tooltipProps={{
        value: data.transaction.closing_date,
        onUpdateOrder: async (value, reasonType, customReason) => {
          await onClosingDate(value, reasonType, customReason);
        },
      }}
    >
      {getDateString(`LLLL d, yyyy`, data.transaction.closing_date) || (
        <SmallBodyText intent={'faded'}>Not Scheduled</SmallBodyText>
      )}
    </SummaryItemWithTooltip>
  );
};
